import { Text } from '@pixi/react'
import { TextStyle } from 'pixi.js'
import { useBalance } from '../../domain/balance/hook/useBalance'

interface SessionWinLoseProps {
  x: number
  y: number
}

const textStyle = new TextStyle({
  fontFamily: 'Arial',
  fontSize: 24,
  fill: '#ffffff',
})
export const SessionWinLose = (props: SessionWinLoseProps) => {
  const { currency, sessionWinLose } = useBalance()
  return (
    <Text
      text={`Session Net Position: ${sessionWinLose} ${currency}`}
      x={props.x}
      y={props.y}
      style={textStyle}
      anchor={0.5}
    />
  )
}
